import React from 'react';
import VerticalAlignBottomSharpIcon from '@material-ui/icons/VerticalAlignBottomSharp';
import Arrow from '@material-ui/icons/ArrowDropDown';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/components/downloadMenuStyle';
import menuStyles from 'assets/jss/material-dashboard-pro-react/customSelectStyle';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import { BodyS } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);
// @ts-ignore
const useMenuStyles = makeStyles(menuStyles);

interface IDownloadMenuItem {
	name: string;
	onClick: () => void;
}

interface IDownloadMenuProps {
	items: IDownloadMenuItem[];
	disabled?: boolean;
}

const DownloadMenu = ({ items, disabled }: IDownloadMenuProps) => {
	const [anchorEl, setAnchorEl] = React.useState<HTMLSpanElement | null>(null);
	const classes = useStyles();

	const menuClasses = useMenuStyles();

	const iconMenuClasses = classNames({
		[classes.iconMenu]: true,
		[classes.iconMenuActive]: !disabled,
		[classes.iconMenuDisabled]: disabled,
	});

	return (
		<span>
			<span
				onClick={(event: React.MouseEvent<HTMLSpanElement>) => !disabled && setAnchorEl(event.currentTarget)}
				className={iconMenuClasses}
				id="download-button"
			>
				<VerticalAlignBottomSharpIcon />
				<Arrow className={classes.iconArrow} />
			</span>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				open={Boolean(anchorEl)}
				onClose={() => setAnchorEl(null)}
				className={classes.downloadDropdown}
			>
				{items.map(({ name, onClick }) => (
					<MenuItem
						key={name}
						onClick={onClick}
						classes={{ root: menuClasses.selectMenuItem }}
						id={`download-menu-option-${name}`}
					>
						<BodyS disableMargin>{translate('table.download', name)}</BodyS>
					</MenuItem>
				))}
			</Menu>
		</span>
	);
};

export default DownloadMenu;
